import { useRef } from 'react';
import { Box, Grid } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import useUser from 'store/user/useUser';
import useStudent from 'store/student/useStudent';
import CollegePatientList from './CollegePatientList';

import PatientsList from './PatientsList';
import StudentList from './StudentList';
import ClassSectionList from './ClassSectionList';
import StudentSelectGuidePanel from './StudentSelectGuidePanel';

const professorFieldSx = {
  flex: 1,
  minWidth: 0,
};

const SearchToolbar = () => {
  const { student_uuid: user_id, isStudent } = useUser();
  const { student_uuid: selectedStudentUuid } = useStudent();
  const showStudentSelectGuide = !isStudent && !selectedStudentUuid;
  const professorDropdownWidthRef = useRef<HTMLDivElement>(null);

  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      sx={{ zIndex: zIndex.modal, overflow: 'visible' }}
    >
      {isStudent ? (
        <Grid item xs={10}>
          <PatientsList user_id={user_id} />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Box
            ref={professorDropdownWidthRef}
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              gap: 1,
            }}
          >
            <Box sx={professorFieldSx}>
              <CollegePatientList
                user_id={user_id}
                matchDropdownWidthRef={professorDropdownWidthRef}
              />
            </Box>
            <Box sx={professorFieldSx}>
              <ClassSectionList
                user_id={user_id}
                matchDropdownWidthRef={professorDropdownWidthRef}
              />
            </Box>
            <Box
              sx={{
                ...professorFieldSx,
                position: 'relative',
                overflow: 'visible',
              }}
            >
              <StudentList
                user_id={user_id}
                matchDropdownWidthRef={professorDropdownWidthRef}
              />
              {showStudentSelectGuide ? <StudentSelectGuidePanel /> : null}
            </Box>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default SearchToolbar;
